module.exports = __webpack_public_path__ + "static/media/quindio-44.fbbfd24d.jpg";